(() => {
  'use strict';
  const configNode = document.getElementById('calio-currency-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const countryCurrencies = {US:'USD',CA:'CAD',GB:'GBP',AU:'AUD',NZ:'NZD',CH:'CHF',SE:'SEK',DK:'DKK',PL:'PLN',NO:'NOK',CZ:'CZK',HU:'HUF',RO:'RON',IS:'ISK'};
  'AT BE BG HR CY EE FI FR DE GR IE IT LV LT LU MT NL PT SK SI ES'.split(' ').forEach(c => countryCurrencies[c] = 'EUR');
  const key = 'calio-display-country-v1';
  const ratesKey = 'calio-display-rates-v1';
  const geoKey = 'calio-display-geo-v1';
  const day = 86400000;
  const read = (store, name) => { try { return JSON.parse(store.getItem(name)); } catch { return null; } };
  const write = (store, name, value) => { try { store.setItem(name, JSON.stringify(value)); } catch {} };
  let persistent, session;
  try { persistent = window.localStorage; session = window.sessionStorage; } catch {}
  let country = config.country || 'US';
  let currency = 'USD';
  let rates = {USD:1};
  let manual = false;
  let ratesFailed = false;
  let scheduled = false;
  const originals = new WeakMap();
  const names = {...config.countries};
  const displayNames = new Intl.DisplayNames(['en'], {type:'region'});
  Object.keys(countryCurrencies).forEach(c => { if (!names[c]) names[c] = displayNames.of(c); });
  const validCountry = c => typeof c === 'string' && /^[A-Z]{2}$/.test(c);
  const codeFor = c => countryCurrencies[c] || 'USD';
  const requestJSON = async url => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4500);
    try {
      const response = await fetch(url, {signal:controller.signal, credentials:url.startsWith('/')?'same-origin':'omit',referrerPolicy:'no-referrer'});
      if (!response.ok) throw new Error('Unavailable');
      return await response.json();
    } finally { clearTimeout(timer); }
  };
  const format = amount => new Intl.NumberFormat('en-US',{style:'currency',currency,currencyDisplay:'code',minimumFractionDigits:2,maximumFractionDigits:2}).format(amount);
  function render() {
    const requested = codeFor(country);
    currency = Number.isFinite(rates[requested]) && rates[requested] > 0 ? requested : 'USD';
    document.documentElement.dataset.calioDisplayCurrency = currency;
    document.documentElement.dataset.calioDisplayCountry = country;
    if (!names[country]) names[country] = displayNames.of(country);
    document.querySelectorAll('[data-calio-money]').forEach(node => {
      const cents = Number(node.dataset.calioMoney);
      if (!Number.isFinite(cents)) return;
      const previous = originals.get(node);
      if (!previous) originals.set(node, {cents,text:node.textContent});
      else if (previous.cents !== cents) originals.set(node,{cents,text:new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',currencyDisplay:'code'}).format(cents/100)});
      const next = currency === 'USD' ? originals.get(node).text : format(cents / 100 * rates[currency]);
      if (node.textContent !== next) node.textContent = next;
    });
    document.querySelectorAll('[data-calio-country]').forEach(select => {
      if (!select.dataset.ready) {
        const priority = ['US','CA','GB','AU','NZ'];
        const countries = [...priority,...Object.keys(names).filter(c => !priority.includes(c)).sort((a,b) => names[a].localeCompare(names[b]))];
        const options = countries.map(c => {
          const option = document.createElement('option');
          option.value = c;
          option.textContent = `${names[c]} (${Number.isFinite(rates[codeFor(c)]) ? codeFor(c) : 'USD'})`;
          return option;
        });
        select.replaceChildren(...options);
        select.dataset.ready = '1';
      }
      for (const option of select.options) {
        const effective = Number.isFinite(rates[codeFor(option.value)]) ? codeFor(option.value) : 'USD';
        const label = `${names[option.value]} (${effective})`;
        if (option.textContent !== label) option.textContent = label;
      }
      if (![...select.options].some(o => o.value === country)) {
        const option=document.createElement('option');option.value=country;option.textContent=`${names[country]} (${currency})`;select.appendChild(option);
      }
      select.value = country;
      select.disabled = false;
    });
    document.querySelectorAll('[data-calio-currency-notice]').forEach(node => {
      if (!originals.has(node)) originals.set(node, node.textContent);
      const unavailable = ratesFailed && requested !== 'USD' && currency === 'USD';
      node.hidden = currency === 'USD' && !unavailable;
      const next = unavailable ? config.unavailable : originals.get(node);
      if (node.textContent !== next) node.textContent = next;
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; observer.disconnect(); render(); observe(); });
  }
  const observer = new MutationObserver(schedule);
  const observe = () => observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-calio-money']});
  const saved = read(persistent,key);
  if (saved && validCountry(saved.country) && Date.now()-saved.time < 180*day) { country=saved.country; manual=true; }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-calio-country]')) return;
    if (!validCountry(event.target.value)) return;
    country=event.target.value; manual=true;
    write(persistent,key,{country,time:Date.now()});
    schedule();
  });
  async function loadRates() {
    const cached = read(persistent,ratesKey);
    const isValid = data => data && Object.values(countryCurrencies).every(c=>c==='USD'||Number.isFinite(data[c]) && data[c]>0);
    if (cached && Date.now()-cached.time < day && isValid(cached.rates)) { rates=cached.rates; schedule(); return; }
    try {
      const quotes=[...new Set(Object.values(countryCurrencies))].filter(c=>c!=='USD').join(',');
      const rows=await requestJSON('https://api.frankfurter.dev/v2/rates?base=USD&quotes='+quotes);
      const next={USD:1};
      if (!Array.isArray(rows)) throw new Error('Invalid rates');
      for (const row of rows) {
        const date=Date.parse(row.date);
        if(row.base==='USD' && Number.isFinite(row.rate) && row.rate>0 && date<=Date.now()+day && Date.now()-date<7*day) next[row.quote]=row.rate;
      }
      if(!isValid(next)) throw new Error('Missing rates');
      rates=next;write(persistent,ratesKey,{rates,time:Date.now()});
    } catch { ratesFailed=true; }
    schedule();
  }
  async function locate() {
    if(manual) return;
    const cached=read(session,geoKey);
    if(cached && validCountry(cached.country) && Date.now()-cached.time<day) { country=cached.country;schedule();return; }
    try {
      const root=config.root.endsWith('/')?config.root:config.root+'/';
      const data=await requestJSON(root+'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false');
      const detected=data.detected_values?.country?.handle || data.suggestions?.[0]?.parts?.country?.handle;
      if(validCountry(detected)) {
        write(session,geoKey,{country:detected,time:Date.now()});
        if(!manual) country=detected;
      }
    } catch {}
    schedule();
  }
  render();observe();
  loadRates();locate();
})();
